import React, { createContext, useMemo, useState } from 'react';

export const CurrentScreenContext = createContext();

export const CurrentScreenProvider = ({ children }) => {
    const [currentScreen, setCurrentScreen] = useState(null);

    // Memoize the value so consumers only re-render when currentScreen actually
    // changes, not on every render of any parent above this high-in-the-tree
    // provider (setCurrentScreen is a stable useState setter).
    const value = useMemo(() => ({ currentScreen, setCurrentScreen }), [currentScreen]);

    return (
        <CurrentScreenContext.Provider value={value}>
            {children}
        </CurrentScreenContext.Provider>
    );
};